import React from 'react';
import ImageGalleryminority from '../components/ImageGalleryminority';
// import IRCTVDonationCard from "./IRCTVDonationCard";
import { useStats } from '../hooks/useStats';

const IRCMINORITY = () => {
  const { stats, loading } = useStats();

  // Format date for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return '31-Jan-2025';
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Format number with commas
  const formatNumber = (num) => {
    if (!num && num !== 0) return 'Loading...';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handlePhoneClick = (phoneNumber) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const telLink = `tel:${cleanedNumber}`;
    window.location.href = telLink;
  };

  if (loading) return <div className="loading">Loading statistics...</div>;

  return (
    <>
      <div className="about-us-container">
        <section className="activities-details">
          <button 
            onClick={() => window.history.back()}
            style={{
              marginBottom: '10px',
              padding: '8px 10px',
              backgroundColor: '#255fe8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ← Back to All Activities
          </button>
          <div className="activity-intro">
            <h2>OUR ACTIVITIES</h2>
            <p>
              All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
            </p>
          </div>

          <ImageGalleryminority />

          {/* IRC Minority Development Center */}
          <div className="activity-card">
           
            <div className="activity-content">
               <div className="activity-header">
              <h3>IRC MINORITY DEVELOPMENT CENTER (MDC)</h3>
            </div>
              <p>
                Empowering minorities through our Development Centre, we provide a spectrum of services only for students, including career guidance, scholarships for government and private medical admissions, assistance for international admissions, business guidance, documentation support (Pan Card, Passport, Shop Act, Udyog Aadhar), MPSC/UPSC guidance, job information, government relief initiatives, EWS and cast validity schemes, and education loan guidance.
              </p>
              <p>
                Committed to fostering inclusive growth, we strive to pave the way for success and equal opportunities.
              </p>

              <div className="clinic-card">
              <h3>Branch-1: Roshan Gate</h3>

                <p><strong>Name:</strong> IRC Minority Development Center (MDC)</p>
                <p><strong>Address:</strong> Sultan Complex, Near Shalimar Book House, Roshan Gate Road, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Take A Video Tour:</strong> Click Here For Video</p>
                <p><strong>Date of Inauguration:</strong> 17-May-2024</p>
                <p><strong>No. of Beneficiary:</strong> {formatNumber(stats.minority_beneficiaries)} (till {formatDisplayDate(stats.minority_date)})</p>
                <p><strong>Contact No: </strong><span
                  className="contact-number"
                  onClick={() => handlePhoneClick('80-5509-5509')}
                  style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                >
                  80-5509-5509
                </span>
                </p>
              </div>
            </div>

          
            <div className="activity-content">
              <div className="clinic-card">
              <h3>Branch-2: Ibrahim Park</h3>

                <p><strong>Name:</strong> IRC Minority Development Center (MDC)</p>
                <p><strong>Address:</strong> Gut No. 33, Soniya Nagar, Ibrahim Park, Satara Deolai Parisar, Beed By Pass Road, Aurangabad.</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Take A Video Tour:</strong> Click Here For Video</p>
                <p><strong>Date of Inauguration:</strong> NA</p>
                <p><strong>No. of Beneficiary:</strong> {formatNumber(stats.minority_beneficiaries)} (till {formatDisplayDate(stats.minority_date)})</p>
                <p><strong>Contact No: </strong><span
                  className="contact-number"
                  onClick={() => handlePhoneClick('9607-9607-69')}
                  style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                >
                  9607-9607-69
                </span>
                </p>
              </div>
            </div>
            {/* <IRCTVDonationCard
              title="IRC MINORITY DEVELOPMENT CENTER (MDC)"
              subtitle="Your donation makes a difference"
              description="Donate Us continue providing quality content and services to our community."
              amount="₹5000"
              purpose="Cause: IRC MINORITY DEVELOPMENT CENTER (MDC)"
            /> */}
          </div>
        </section>
      </div>
    </>
  );
};

export default IRCMINORITY;